import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './ErrorPage.css';

export function ErrorPage({ errorMessage }) {
  const [secondsLeft, setSecondsLeft] = useState(5);

  useEffect(() => {
    if (secondsLeft >= 0) {
      setInterval(() => {
        setSecondsLeft((prev) => prev - 1);
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (secondsLeft < 0) window.location.assign(`https://${process.env.REACT_APP_ENDPOINT_principalDomain}`);
  }, [secondsLeft]);

  return (
    <>
      <div className="logIn-errorMessage-container">
        <p className="main-message">{errorMessage}</p>
        <p className="secondary-message">
          {' '}
          Você será redirecionado para a página principal em
          {' '}
          {secondsLeft > 0 ? secondsLeft : 0}
          ...
        </p>
        <a className="secondary-message" href={`https://${process.env.REACT_APP_ENDPOINT_principalDomain}`}> Ou clicando aqui.</a>
      </div>
    </>
  );
}

ErrorPage.propTypes = {
  errorMessage: PropTypes.string,
};

ErrorPage.defaultProps = {
  errorMessage: 'Ops! Tivemos um problema.',
};
